export { default } from './setting.component';
